import { Component } from '@angular/core';

@Component({
  selector: 'app-prepaid-user-guide',
  templateUrl: './prepaid-user-guide.component.html',
  styleUrls: ['./prepaid-user-guide.component.scss'],
})
export class PrepaidUserGuideComponent {}
